module.exports = __webpack_public_path__ + "img/topic1-r.8254db96.jpg";